export const formatGSTN = (gstin: string | undefined | null): string => {
  if (!gstin) return '';
  
  // Ensure GSTN is consistent (uppercase)
  const formattedGSTN = gstin.toUpperCase();
  
  // GSTN format: 22AAAAA0000A1Z5
  return formattedGSTN;
};

export const isValidGSTN = (gstin: string | undefined | null): boolean => {
  if (!gstin) return false;
  
  // Sanitize input
  const sanitizedGSTN = gstin.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  
  // GSTN must be 15 characters long
  if (sanitizedGSTN.length !== 15) return false;
  
  // Check state code (first 2 digits should be between 01-38)
  const stateCode = parseInt(sanitizedGSTN.substring(0, 2), 10);
  if (isNaN(stateCode) || stateCode < 1 || stateCode > 38) return false;
  
  // Check PAN portion (positions 3-12)
  const panPortion = sanitizedGSTN.substring(2, 12);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  if (!panRegex.test(panPortion)) return false;
  
  // The 13th character can be Z for composition dealers
  
  // The 14-15th character is the check digit
  
  return true;
};

export const validateGSTN = (gstin: string | undefined | null): string => {
  // If GSTN is empty, it's valid (might be optional in some cases)
  if (!isValidGSTN(gstin)) {
    return 'Invalid GSTN format. Expected format: 22AAAAA0000A1Z5';
  }
  return '';
}; 